module.exports = __webpack_public_path__ + "img/ham.5eec282f.jpg";